import * as React from 'react';
import poab1 from '../../../../../assets/images/static_pages/perks_of_account_balance_1.svg';
import poab2 from '../../../../../assets/images/static_pages/perks_of_account_balance_2.svg';
import poab3 from '../../../../../assets/images/static_pages/perks_of_account_balance_3.svg';
import arrow from '../../../../../assets/images/static_pages/forward_arrow.svg';
import { ViewMessageRates } from './ViewMessageRates';

export const PerksOfAccountBalance = () => {
  const datas = [
    {
      id: 1,
      title: 'Pre-filled Account & Billed-as-you-go',
      bullets: [
        'Every Avochato plan comes with a pre-filled account balance to help you get started sending messages.',
        'Account balance is billed-as-you-go and allows you to pay for SMS and multimedia messages, carrier fees, international rates, WhatsApp fees, and phone call minutes on your own terms.',
      ],
      image: poab1,
    },
    {
      id: 2,
      title: '3 Ways to Top-up Your Balance',
      bullets: [
        "Manually, with one-time top ups through Avochato's billing portal.",
        'Automatically by setting a lower limit and a top up amount that replenishes the account once that lower limit is hit.',
        'Contact our sales team for volume pricing discounts when you commit to a long term contract.',
      ],
      image: poab2,
      list: true,
    },
    {
      id: 3,
      title: 'Get Notified When Balance is Low',
      bullets: [
        'Avochato also offers an upper limit that you can specify to make sure you stay within your budget.',
        'You will be notified when your account balance drops below a given threshold, or when your account is auto-topped up.',
      ],
      image: poab3,
    },
  ];

  const sections = datas.map((data) => {
    const bullets = data.bullets.map((bullet, idx) => {
      const symbol = data.list ? (
        <p className="orange bold-800 fsz-14">
          {idx + 1}
          .
        </p>
      ) : (
        <img className="arrow" src={arrow} alt="forward-arrow" />
      );

      return (
        <div className="flex mt-10">
          <div className="mr-5">{symbol}</div>
          <p key={bullet} className="fsz-14">
            {bullet}
          </p>
        </div>
      );
    });

    return (
      <div key={data.title} className="col-section">
        <img src={data.image} alt="" />
        <p className="fsz-20 bold-800 mt-15 center">{data.title}</p>
        {bullets}
      </div>
    );
  });

  return (
    <div id="perks-of-balance">
      <p className="burnt-orange fsz-14 bold-800 uppercase mb-5">Perks of Account Balance</p>
      <p className="header">Account balance gives you the flexibility to use the product freely</p>
      <div className="section-containers">
        {sections}
      </div>
    </div>
  );
};
